import axios from '../api/axios';

const API_URL = 'sales';

// Create a refund for a specific sale
export const createRefund = async (saleId, refundData) => {
  const response = await axios.post(`${API_URL}/${saleId}/refund`, refundData);
  return response.data;
};

// Get all refunds
export const getRefunds = async () => {
  const response = await axios.get(`${API_URL}/refunds`);
  return response.data;
};

// Get a refund by its ID
export const getRefundById = async (id) => {
  const response = await axios.get(`${API_URL}/refunds/${id}`);
  return response.data;
};
